import React from "react";
import PropTypes from "prop-types";
import Table from "components/Table/Table.jsx";

export default function BindingMatrix({ agents, assetById }) {
  if (!agents || agents.length === 0) {
    return <div>No binding agents configured.</div>;
  }

  const getMappingRules = agent => {
    if (Array.isArray(agent.attribute_mappings) && agent.attribute_mappings.length > 0) {
      return agent.attribute_mappings;
    }

    const legacyTemplate = agent.attribute_mapping_template || {};
    return Object.keys(legacyTemplate).map(targetKey => ({
      source_key: legacyTemplate[targetKey],
      target_key: targetKey,
      transform: null
    }));
  };

  const getSourceLabel = agent => {
    if (agent.source_type === "asset_attribute") {
      return (assetById[agent.source_asset] && assetById[agent.source_asset].name) || "Asset Attribute";
    }
    return `Device Status (${(agent.devices || []).length})`;
  };

  const tableHead = [
    "Agent Name",
    "Asset",
    "Source",
    "Sync Mode",
    "Status",
    "Mappings"
  ];

  const tableData = agents.map(agent => {
    const mappingRules = getMappingRules(agent);
    const mappingLabel =
      mappingRules.length > 0
        ? mappingRules.map(rule => `${rule.source_key} -> ${rule.target_key}`).join(", ")
        : "-";

    return [
      agent.name,
      (assetById[agent.asset] && assetById[agent.asset].name) || "Unknown",
      getSourceLabel(agent),
      agent.sync_mode || "on_read",
      agent.active ? "Active" : "Inactive",
      mappingLabel
    ];
  });

  return <Table tableHeaderColor="info" tableHead={tableHead} tableData={tableData} />;
}

BindingMatrix.propTypes = {
  agents: PropTypes.array,
  assetById: PropTypes.object
};
